import { createFileRoute } from "@tanstack/react-router";
import { PoPrint } from "@/features/purchase-orders/PoPrint";

export const Route = createFileRoute("/_authenticated/purchase-orders/$poId/print")({
  component: () => {
    const { poId } = Route.useParams();
    return <PoPrint id={poId} />;
  },
});
